import React, { Component } from 'react';
import style from './style.module.scss';
import { Button, Dropdown, Icon, Input, Menu, Tooltip } from 'antd';
import getSVG from '../../../../utils/commonSVG';
import urlConfig from '../../../../config/index';
import moment from 'moment';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import languageFile from '../../../../../public/languages/Translation';
import {
  availableLanguages,
  language2letterCode,
} from '../../../../utils/languageConstants';
import { fetchLanguageValues } from '../../../../utils/languageService';
import _ from 'lodash';
import cookie from '../../../../utils/cookie';
import LogoutAction from '../../../../routers/MainFrame/action/LogoutAction';
import GetCustomiNavigationAction from '../../../IntegrationControl/action/GetCustomiNavigationAction';
import GetCustomNavigationStore from '../../../IntegrationControl/store/GetCustomNavigationStore';
import GetIntegrationStore from '../../store/GetIntegrationStore';
import GetUserSettingsStore from '../../store/GetUserSettingsStore';
import { ProgressiveModalWindow } from '../../../../components/ProgressiveModalWindow';
import { RenderModalForm } from '../ProfilePage/children/RenderModalForm';
import { Modal } from 'antd';
import AddProfileAction from '../../action/AddProfileAction';
import UploadProfileIconAction from '../../action/UploadProfileIconAction';
import { message } from 'antd';
import UploadProfileIconStore from '../../store/UploadProfileIconStore';
import AddProfileStore from '../../store/AddProfileStore';
import GetProfilesAction from '../../action/GetProfilesAction';
import { AddPortFolioModal } from '../PortFolioPage/AddPortFolioModal';
import CreatePortfolioAction from '../../action/CreatePortfolioAction';
import CreatePortfolioStore from '../../store/CreatePortfolioStore';
import GetPortfolioDetailsAction from '../../action/GetPortfolioDetailsAction';
import ConfirmationModal from '../../../RestrictedDomains/Children/ConfirmationModal';
import { Radio } from 'antd';
import UpdateBlockedDomainAction from '../../../RestrictedDomains/Action/UpdateBlockedDomainAction';
import GetBlockedPublicEmailAction from '../../../RestrictedDomains/Action/GetBlockedPublicEmailAction';
import GetBlockedPublicEmailDomainStore from '../../../RestrictedDomains/Store/GetBlockedPublicEmailDomainStore';
import UpdateBlockedDomainStore from '../../../RestrictedDomains/Store/UpdateBlockedDomainStore';
import CheckAdminStore from '../../../Settings/store/CheckAdminStore';
import GetWorkspaceAction from '../../../Login/action/GetWorkspaceAction';
import GetProfileStore from '../../store/GetProfilesStore';
import CheckAdminAction from '../../../Settings/action/CheckAdminAction';
import GetDomainDetailsStore from '../../../../flux/dispatcher/store/GetDomainDetailsStore';

var urlName = urlConfig.urlName
var analytics = window.analytics;
const INPUT_CHARACTER_LIMIT = 50;
const SELECT_OPTIONS = [
  {
    text: "Public Email",
    label: "Public Email",
    value: "blockedPublicEmailDomains",
    placeholder: "Domain name",
  },
  {
    text: "Spam",
    label: "Spam",
    value: "blockedSpamDomains",
    placeholder: "Domain name",
  },
  {
    text: "Top Level Domain",
    label: "Top Level Domain",
    value: "blockedTopLevelDomains",
    placeholder: "site.ru",
  },
];
const ADD = "add";
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChatIcon: null,
      languagesList: [],
      apiLangValues: Object.keys(availableLanguages),
      showLogoutPopup: false,
      currentlanguage: localStorage.getItem('language'),
      showSuperUserPopup: false,
      fullscreen: false,
      navigationGroupItems: [],
      fullScreen: true,
      liveChat: true,
      siteSearch: true,
      customNavigationLinks: true,
      knowledgePanel: true,
      featureRequests: false,
      language: false,
      selectedLanguage: 'english',
      newProfileLanguage: 'english',
      supportTickets: true,
      latestUpdates: true,
      productRoadMap: false,
      dateFormat: 'MM/DD/YYYY',
      timeFormat: 'h:mm',
      showProfileMoadal: false,
      inviterUser: [{ role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }],
      nextStep: 1,
      selectedLocationVolume: undefined,
      profileName: '',
      locationVolume: [{ label: '1 location', value: '1' }, { label: '2 - 5 locations', value: '2-5' }, { label: '6 - 20 locations', value: '6-20' }, { label: '20 - 100 locations', value: '20-100' }, { label: '100 - 500 locations', value: '100-500' }, { label: '500+ locations', value: '500+' }],
      selectedTimeZone: undefined,
      selectedDateFormat: "MM/DD/YYYY",
      selectedTimeFormat: 'h:mm',
      selectedTimeStamp: 'UTC',
      dailyReviewSummary: false,
      weeklyReviewSummary: false,
      realTimeGoogleReviewNotification: false,
      realTimeGoogleMediaNotification: false,
      identifyLanguage: false,
      sentimentAnalysisEnable: false,
      setSentimentLanguage: false,
      defaultSentimentLanguage: 'English',
      reviewGenderTagging: false,
      trackCompetitorReviews: false,
      inviterUser: [{ role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }],
      inviteMessage: '',
      domainLogo: '',
      customGenerativeAIToneVoice: false,
      uploadIconLoader: false,
      profileIconURL: '',
      selectedBusiness: undefined,
      newProfileLoading: false,
      showAddProtfolioOptions: false,
      newPortfolio: '',
      loadingPortFolio: false,
      portfolioErrorMessage: '',
      selectedDomainType: SELECT_OPTIONS[0].value,
      formrestrictedModalVisible: false,
      newDomainName: '',
      blockedDomains: [],
      blockedSpamDomain: [],
      blockedTopLevelDomains: [],
      textValue: ''
    }
    this.divRef = React.createRef();
    this.dropdownRef = React.createRef();
    this.dropdownUserRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleOutsideUserClick = this.handleOutsideUserClick.bind(this);

  }
  componentDidMount() {
    fetchLanguageValues().then((values) => { this.setState({ apiLangValues: values }); });
    GetCustomiNavigationAction.getCustomNavigation(urlName);
    document.addEventListener('mousedown', this.handleOutsideClick);
    document.addEventListener('mousedown', this.handleOutsideUserClick);
    document.addEventListener("fullscreenchange", this.handleFullScreenChange);
    GetCustomNavigationStore.bind(this.getCustomNavResponse);
    GetUserSettingsStore.bind(this.getUserSettings);
    document.addEventListener('keydown', this.handleSlashKey);
    this.getInitialData();
    UploadProfileIconStore.bind(this.uploadIconResponse);
    AddProfileStore.bind(this.onAddingProfile);
    CreatePortfolioStore.bind(this.onAddingPortfolio);
    GetBlockedPublicEmailDomainStore.bind(this.getPublicEmailDomainResponse);
    // this.getBlockedDomainName({ searchText: this.state.searchText });
    UpdateBlockedDomainStore.bind(this.updateBlockedDomainResponse);
    GetProfileStore.bind(this.getProfileDetailsRespose);
    GetIntegrationStore.bind(this.onGetIntegrations);

    let chatBoatVisible = localStorage.getItem('showChatIcon');
    if (chatBoatVisible === null) {
      chatBoatVisible = true; // Default value if nothing is stored
    }
    this.setState({ showChatIcon: chatBoatVisible === 'true' ? false : true }, () => {
      setTimeout(() => {
        this.toggleChatIcon(chatBoatVisible);
      }, 2000)
    })
  }


  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    document.removeEventListener('mousedown', this.handleOutsideUserClick);
    document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
    GetCustomNavigationStore.unbind(this.getCustomNavResponse);
    GetUserSettingsStore.unbind(this.getUserSettings)
    document.removeEventListener('keydown', this.handleSlashKey);
    UploadProfileIconStore.unbind(this.uploadIconResponse)
    AddProfileStore.unbind(this.onAddingProfile);
    CreatePortfolioStore.unbind(this.onAddingPortfolio);
    GetBlockedPublicEmailDomainStore.unbind(this.getPublicEmailDomainResponse);
    UpdateBlockedDomainStore.unbind(this.updateBlockedDomainResponse);
    GetProfileStore.unbind(this.getProfileDetailsRespose);
    GetIntegrationStore.bind(this.onGetIntegrations);
  }

  onGetIntegrations = () => {
    let response = GetIntegrationStore.getResponse();
    if (response.whiteLabelImages && response.whiteLabelImages.domainIcon) {
      this.setState({ domainLogo: response.whiteLabelImages.domainIcon, profileIconURL: response.whiteLabelImages.domainIcon })
    }
  }
  getProfileDetailsRespose = () => {
    let { textValue } = this.state;
    let response = GetProfileStore.getResponse();
    this.setState({ showProfileMoadal: response.total < 1 && textValue == '' ? true : false })

  }
  updateBlockedDomainResponse = () => {
    const { status } = UpdateBlockedDomainStore.getResponse();
    if (status === 200) {
      this.setState({ formrestrictedModalVisible: false, formButtonLoading: false, newDomainName: '' })
    } else {
      this.setState({
        buttonLoading: false,
        formButtonLoading: false,
      });
    }
  };
  getBlockedDomainName = ({ searchText }) => {
    this.setState({ tableLoading: true });
    const queryParam = `${urlConfig.urlName}&searchText=${searchText}`;
    // GetBlockedPublicEmailAction.getBlockedPublicEmailDomain(queryParam);
  };

  onAddingPortfolio = () => {
    if (CreatePortfolioStore.getResponse().status === 409) {
      message.warning('You already have a portfolio with this name!', 2);
    } if (CreatePortfolioStore.getResponse().status === 200) {
      analytics.track('Portfolio Creation Completed');
      message.success(languageFile[localStorage.getItem('language')]['28131'], 2);
      this.setState({
        showAddProtfolioOptions: false,
        newPortfolio: '',
        portFolioLoader: true,
      });
      GetPortfolioDetailsAction.getPortfolios({ from: 0, size: 20, portfolioName: '' })
    } else {
      message.warning(CreatePortfolioStore.getResponse().message, 3);
    }
    this.setState({ loadingPortFolio: false })
  }
  onAddingProfile = () => {
    if (AddProfileStore.getResponse().status === 409) {
      message.warning("You already have a profile with this name!", 2)
      this.setState({
        newProfileLoading: false
      })
    }
    else if (AddProfileStore.getResponse().status === 403) {
      message.error("User doesn't have sufficient permission", 2)
      this.setState({
        showAddOptions: false,
        newProfileLoading: false,
        newProfile: ''
      })
    }
    else if (AddProfileStore.getResponse().status === 200) {
      this.handleCancel();
      analytics.track('Profile Creation Completed', { profile_name: AddProfileStore.getResponse().user.profile.profileName });
      this.addAccountMessage();
      localStorage.setItem(
        'profileId',
        AddProfileStore.getResponse().user.profile.profileId
      );
      localStorage.setItem(
        'profileName',
        AddProfileStore.getResponse().user.profile.profileName
      );
      localStorage.setItem(
        'masterLocationFilter',
        AddProfileStore.getResponse().user.profile.masterLocationFilter || 'false'
      );
      this.props.history.push('/settings/integrations');
      this.setState({
        showAddOptions: false,
        newProfile: '',
        profileLoader: true
      });
      GetProfilesAction.getProfiles({ from: 0, size: 20, searchText: '' });
      this.setState({
        newProfileLoading: false, showProfileMoadal: false
      })
    }
    else {
      this.setState({
        newProfileLoading: false
      })
    }

  }


  showHideDeleteConfirmModal = (param, record = null) => {
    let selectedRecord = null;
    let recordType = SELECT_OPTIONS[0].value;
    if (record) {
      selectedRecord = record.domain;
      recordType = record.type;
    }
    this.setState({
      confirmModalVisible: param,
      deleteDomainName: selectedRecord,
      deleteDomainType: recordType,
      selectedDomainType: recordType,
      buttonLoading: false,
    });
  };
  uploadIconResponse = () => {
    if (UploadProfileIconStore.getResponse().status == 200) {
      let profileIconURL = UploadProfileIconStore.getResponse().url
      this.setState({ profileIconURL })
    }
    this.setState({ uploadIconLoader: false })

  }
  getInitialData = () => {
    let response = GetUserSettingsStore.getResponse();
    if (response.status == 200) {
      let { customNavigationLinks, featureRequests, fullScreen, language, knowledgePanel, latestUpdates, liveChat, notifications, productRoadMap, siteSearch, supportTickets, training, dateFormat, timeFormat, selectedLanguage } = response;
      this.setState({ customNavigationLinks, featureRequests, fullScreen, language, knowledgePanel, latestUpdates, liveChat, notifications, productRoadMap, siteSearch, supportTickets, training, dateFormat, timeFormat, selectedLanguage })
      localStorage.setItem('language', selectedLanguage);
      this.forceUpdate();
    }
  }
  handleSlashKey = (event) => {
    if (event.key === "/") {
      const activeElement = document.activeElement;
      const isInputFocused =
        activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA");

      if (!isInputFocused) {
        event.preventDefault();
        if (this.inputRef) {
          this.inputRef.focus();
        }
      }
    }
  };
  getUserSettings = () => {
    let response = GetUserSettingsStore.getResponse();
    if (response.status == 200) {
      let { customNavigationLinks, featureRequests, fullScreen, language, knowledgePanel, latestUpdates, liveChat, notifications, productRoadMap, siteSearch, supportTickets, training, dateFormat, timeFormat, selectedLanguage } = response;
      this.setState({ customNavigationLinks, featureRequests, fullScreen, language, knowledgePanel, latestUpdates, liveChat, notifications, productRoadMap, siteSearch, supportTickets, training, dateFormat, timeFormat, selectedLanguage })
      localStorage.setItem('language', selectedLanguage);
      this.forceUpdate();
    }
  }

  getCustomNavResponse = () => {
    let response = GetCustomNavigationStore.getResponse();
    if (response.status == 200) {
      this.setState({ navigationGroupItems: [...response.hits] })
    }
  }
  handleFullScreenChange = () => {
    if (!document.fullscreenElement) {
      this.setState({ fullscreen: false })
    }
  };
  handleOutsideClick(event) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showLogoutPopup: false });
    }
  }
  handleOutsideUserClick(event) {
    if (this.dropdownUserRef.current && !this.dropdownUserRef.current.contains(event.target)) {
      this.setState({ showSuperUserPopup: false });
    }
  }
  toggleLogoutPopup = () => {
    this.setState((prevState) => ({
      showLogoutPopup: true,
    }));
  };
  toggleSuperUserPopup = () => {
    this.setState((prevState) => ({
      showSuperUserPopup: true,
    }));
  };
  cookierRead() {
    if (cookie.readCookie("userName") && cookie.readCookie("userName") !== 'undefined') {
      return cookie.readCookie("userName")
    } else {
      return cookie.readCookie("userId")
    }
  }
  cookierReadId() {
    return cookie.readCookie("userId")
  }

  handleLogout = () => {
    LogoutAction.log(cookie.readCookie('lctoken'));
    localStorage.removeItem('profileName');
    localStorage.removeItem('masterLocationFilter');
    cookie.eraseCookie('lctoken');
    cookie.eraseCookie('userName');
    cookie.eraseCookie('userId');
    cookie.eraseCookie('superuser');
    cookie.eraseCookie('superusername');
    cookie.eraseCookie("superuserid");
    cookie.eraseCookie('superuserimage');
    sessionStorage.removeItem("workspaceData");
    cookie.eraseCookie("currentAccountId");
    window.location.href = '/login';
  }
  changelanguage = (e) => {
    localStorage.setItem('language', e.key);
    this.setState({
      currentlanguage: e.key,
    });
    this.props.onChangeLanguage(e.key);
  };
  backToAdmin() {
    cookie.eraseCookie('lctoken');
    cookie.createCookie("lctoken",
      cookie.readCookie('superuser'), 2);
    cookie.eraseCookie('superuser');
    cookie.eraseCookie('superusername');
    cookie.eraseCookie("superuserid");
    cookie.eraseCookie('superuserimage');
    sessionStorage.getItem('workspaceDataSuperUser') && sessionStorage.setItem('workspaceData', sessionStorage.getItem('workspaceDataSuperUser'));
    cookie.readCookie('currentAccountIdSuperUser') && cookie.createCookie('currentAccountId', cookie.readCookie('currentAccountIdSuperUser'));
    sessionStorage.removeItem('workspaceDataSuperUser');
    cookie.eraseCookie('currentAccountIdSuperUser');
    CheckAdminAction.check(urlName);
    GetWorkspaceAction.getWorkspace();
    this.props.changeToProfilesPage('backToAdmin');
  }
  onChangePlusDropDown = (key) => {
    if (key.key == 'profile') {
      this.setState({ showProfileMoadal: true })
    }
    if (key.key == 'portfolio') {
      this.setState({ showAddProtfolioOptions: true })
    }
    if (key.key == 'domain') {
      this.setState({ formrestrictedModalVisible: true })
    }
    if (key.key == 'tier') {
      // history.push(`/authorize/admin/tier-control/create-tier`)
      window.location = `/authorize/admin/tier-control/create-tier`
    }
    if (key.key == 'link') {
      // history.push(`/authorize/admin/tier-control/create-tier`)
      window.location = `/authorize/admin/domain-control?rightnav`
    }

  }
  confirmModal = (handleCancel) => {
    return Modal.confirm({
      title: 'Confirm',
      centered: true,
      content: 'Are you sure you want to cancel',
      className: 'confirm-modal-window',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleCancel()
      },
    })
  };
  handlePortfolioCancel = () => {
    this.setState({
      showAddProtfolioOptions: false,
    })
  }
  handleCancel = (e) => {
    this.setState({
      showProfileMoadal: false,
      inviterUser: [{ role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }],
      nextStep: 1,
      selectedLocationVolume: undefined,
      profileName: '',
      locationVolume: [{ label: '1 location', value: '1' }, { label: '2 - 5 locations', value: '2-5' }, { label: '6 - 20 locations', value: '6-20' }, { label: '20 - 100 locations', value: '20-100' }, { label: '100 - 500 locations', value: '100-500' }, { label: '500+ locations', value: '500+' }],
      selectedTimeZone: undefined,
      selectedDateFormat: "MM/DD/YYYY",
      selectedTimeFormat: 'h:mm',
      selectedTimeStamp: 'UTC',
      dailyReviewSummary: false,
      weeklyReviewSummary: false,
      realTimeGoogleReviewNotification: false,
      realTimeGoogleMediaNotification: false,
      identifyLanguage: false,
      sentimentAnalysisEnable: false,
      setSentimentLanguage: false,
      defaultSentimentLanguage: 'English',
      reviewGenderTagging: false,
      trackCompetitorReviews: false,
      inviterUser: [{ role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }, { role: 'READ_ONLY', invitees: '', error: false }],
      inviteMessage: '',
      domainLogo: GetIntegrationStore.getResponse().whiteLabelImages.domainIcon,
      customGenerativeAIToneVoice: false,
      uploadIconLoader: false,
      profileIconURL: GetIntegrationStore.getResponse().whiteLabelImages.domainIcon,
      selectedBusiness: undefined
    })
  }
  onCancelModal = () => {
    return this.confirmModal(this.handleCancel)
  }
  addNewProfile = () => {
    this.setState({ newProfileLoading: true })
    let data = {};
    data['accountId'] = cookie.readCookie('currentAccountId');
    data['profileName'] = this.state.profileName;
    data.creatorId = cookie.readCookie('userId');
    data.domainName = urlName;
    data.locationVolume = this.state.selectedLocationVolume;
    data.businessIndustry = this.state.selectedBusiness;
    data.profileSettings = {
      profileIcon: this.state.profileIconURL,
      defaultLanguage: this.state.newProfileLanguage,
      reviewTimeStamp: {

        timeFormat: this.state.selectedTimeStamp
      },
      dateFormat: {
        label: this.state.selectedDateFormat,
        value: this.state.selectedDateFormat
      },
      timeZone: this.state.selectedTimeZone,
      timeFormat: this.state.selectedTimeFormat,
      reportSettings: {
        dailyReviewSummary: this.state.dailyReviewSummary,
        weeklyReviewSummary: this.state.weeklyReviewSummary,
        realTimeGoogleReviewNotification: this.state.realTimeGoogleReviewNotification,
        realTimeGoogleMediaNotification: this.state.realTimeGoogleMediaNotification
      },
      hasLanguageDetection: this.state.identifyLanguage,
      hasSentimentAnalysis: this.state.sentimentAnalysisEnable,
      hasSentimentDetectionLanguage: this.state.sentimentAnalysisEnable ? this.state.setSentimentLanguage : 'false',
      sentimentDetectionLanguage: this.state.setSentimentLanguage ? this.state.defaultSentimentLanguage : '',
      customGenerativeAIToneVoice: this.state.customGenerativeAIToneVoice,
      reviewGenderTagging: this.state.reviewGenderTagging,
      competitorReviews: this.state.trackCompetitorReviews


    }
    data.userInviteList = [];
    this.state.inviterUser.map((items) => {
      if (items.invitees.length > 0) {
        data.userInviteList.push({ role: items.role, invitee: items.invitees })
      }
    })
    data.message = this.state.inviteMessage;

    AddProfileAction.addProfile(data);
  }
  previousStepButtonHandler = () => {
    if (this.state.nextStep !== 1) {
      this.setState({ nextStep: this.state.nextStep - 1 })
    }
  }
  changeInvities = (index, value) => {
    let { inviterUser } = this.state;
    inviterUser.map((item, ind) => {
      if (index == ind) {
        item.role = value;
      }
    })
  }
  onChangeCreteProfileDetails = (field, value, index) => {
    if (field == 'profileName') {
      if (value.length > 20) {
        message.error('Profile names can only have a maximum of 20 characters');
      }
      else this.setState({ [field]: value, validationInpuClass: '' })
    }
    else if (field == 'newProfileLanguage') {
      if (value.length > 0) {
        this.setState({ validationSelectClass: '', [field]: value })
      }
    }
    else if (field == 'selectedTimeZone') {
      this.setState({ validationTimeZoneClass: '', [field]: value })
    }
    else if (field == 'inviteEmail') {
      let { inviterUser } = this.state;
      let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      inviterUser.map((item, ind) => {
        if (ind == index) {
          if (pattern.test(value) && item.error || item.error && value == '') {
            item.error = false;
          }
          item.invitees = value
        }

      })
      this.setState({ inviterUser })
    }
    else { this.setState({ [field]: value }) }
  }
  nextStepButtonHandler = () => {
    let validation = false;
    if (this.state.nextStep == 1) {
      if (this.state.profileName.length == 0) {
        validation = true;
        this.setState({ validationInpuClass: 'invalid' })
      }
    }
    if (this.state.nextStep == 2) {
      if (this.state.newProfileLanguage == undefined) {
        validation = true;
        this.setState({ validationSelectClass: 'invalid' })
      }
      if (this.state.selectedTimeZone == undefined) {
        validation = true;
        this.setState({ validationTimeZoneClass: 'invalid' })
      }
    }
    if (this.state.nextStep == 5) {

      let { inviterUser } = this.state;
      let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      inviterUser.map((items) => {
        if (items.invitees.length > 0 && !pattern.test(items.invitees)) {
          items.error = true;
          validation = true;
        }
      })
      this.setState({ inviterUser })
    }
    if (this.state.nextStep !== 6 && !validation) {
      this.setState({ nextStep: this.state.nextStep + 1 })
    }

  }

  handleProfileIconChange = (fileList) => {
    this.setState({ uploadIconLoader: true })
    const formData = new FormData();
    formData.append('image', fileList.file);
    formData.append('imageType', 'profileIcon')
    formData.append('domainName', urlName)
    UploadProfileIconAction.upload(formData)
  }

  fullScreenBrowserWindow = () => {
    this.setState({ fullscreen: true })
    document.documentElement.requestFullscreen();
  };

  exitFullScreen = () => {
    this.setState({ fullscreen: false })
    document && document.exitFullscreen() && document.exitFullscreen();
  }
  openKnowledgePanel = () => {
    window.open('https://support.localclarity.com/portal/en/kb', '_blank');

  }
  openSupportTicket = () => {
    window.open(' https://support.localclarity.com/portal/en/home', '_blank');
  }
  customNavRendering = (item, keys) => {
    if (item.linkType === 'INTERNAL') {
      return (
        <div className='custom-links__item' key={keys}>
          <Tooltip
            title={item.tooltipComment}
            placement='top'
            key={keys}>
            <Link to={'/authorize/iframe?externallink=' + item.link}>
              <span className='nav-icon'>
                <img
                  src={
                    item.imageFile +
                    '?param=' +
                    moment().format('LTS')
                  }
                />
              </span>
              <span className='nav-label'>
                {' '}
                {_.truncate(item.tabName, { length: 14 })}
              </span>
            </Link>
          </Tooltip>
        </div>
      );
    } else {
      return (
        <div className='custom-links__item' key={keys}>
          <Tooltip
            title={item.tooltipComment}
            placement='top'
            key={keys}>
            <a target='_blank' href={item.link}>
              <span className='nav-icon'>
                <img
                  src={
                    item.imageFile +
                    '?param=' +
                    moment().format('LTS')
                  }
                />
              </span>
              <span className='nav-label'>
                {' '}
                {_.truncate(item.tabName, { length: 14 })}
              </span>
            </a>
          </Tooltip>
        </div>
      );
    }

  }

  handleDivClick = () => {
    this.simulateControlK();
  };
  simulateControlK = () => {
    const event = new KeyboardEvent('keydown', {
      key: 'k',
      code: 'KeyK',
      ctrlKey: true,
    });
    this.divRef.current.dispatchEvent(event);
  };

  addNewPortfolio = () => {
    if (_.startCase(this.state.newPortfolio).length === 0) {
      message.warning('please enter a portfolio name');
    } else if (!this.state.portfolioErrorMessage) {
      this.setState({ loadingPortFolio: true, searchText: '' })
      localStorage.setItem('logo', `/images/${urlConfig.urlName}/logo-icon.png`);
      localStorage.setItem('logoText', `/images/${urlConfig.urlName}/logo-text.png`);
      CreatePortfolioAction.createPortfolio({
        portfolioName: this.state.newPortfolio,
      });
    }
  }

  newPortfolioChange = (event) => {
    if (/^[a-zA-Z_0-9- ]*$/.test(event.target.value) === false) {
      this.setState({
        portfolioErrorMessage:
          'Portfolio names cannot contain special characters',
        newPortfolio: event.target.value,
      });
    } else if (event.target.value.length > 20) {
      this.setState({
        portfolioErrorMessage:
          languageFile[localStorage.getItem('language')]['28121'],
      });
    } else {
      this.setState({
        newPortfolio: event.target.value,
        portfolioErrorMessage: '',
      });
    }
  }
  showHideFormModal = ({ isShow, record, mode }) => {
    let newDomainName = "";
    let selectedDomainType = SELECT_OPTIONS[0].value;
    this.setState({
      formrestrictedModalVisible: isShow,
      formButtonLoading: false,
      newDomainName: newDomainName,
      selectedDomainType: selectedDomainType,
    });
  };
  CheckIsValidDomain = (domain) => {
    const domainRegx = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
    return domain.match(domainRegx);
  };

  getPublicEmailDomainResponse = () => {
    const {
      status,
      blockedSpamDomain,
      blockedPublicEmail,
      blockedTopLevelDomains,
    } = GetBlockedPublicEmailDomainStore.getResponse();
    if (status === 200) {
      let blockedDomain = this.generateTableResponse(
        blockedSpamDomain,
        blockedPublicEmail,
        blockedTopLevelDomains,
        this.state.tableFilterOptions || []
      );

      this.setState({
        blockedDomains: blockedDomain,
        blockedSpamDomain: blockedSpamDomain ? blockedSpamDomain : [],
        blockedPublicEmail: blockedPublicEmail ? blockedPublicEmail : [],
        blockedTopLevelDomains: blockedTopLevelDomains
          ? blockedTopLevelDomains
          : [],
      });
    }

  };
  updateBlockedDomain = (type) => {
    let isRepeat = true;
    let payload = {
      domain: urlConfig.urlName,
      blockedPublicEmailDomains: this.state.blockedPublicEmail || [],
      blockedSpamDomains: this.state.blockedSpamDomain || [],
      blockedTopLevelDomains: this.state.blockedTopLevelDomains || [],
      blockDomainRequest: {
        domainType: "",
        request: "",
        updatedDomain: "",
        existingDomain: "",
        existingDomainType: "",
      },
    };
    if (
      type === ADD &&
      !payload[this.state.selectedDomainType].includes(this.state.newDomainName)
    ) {
      // ADD new domains
      payload.blockDomainRequest.domainType = this.state.selectedDomainType;
      payload.blockDomainRequest.request = ADD;
      payload.blockDomainRequest.updatedDomain = this.state.newDomainName;
      isRepeat = false;
    }
    // ADD new domains
    // API call >> Updating domains
    if (!isRepeat) {
      this.setState({ buttonLoading: true, formButtonLoading: true });
      UpdateBlockedDomainAction.updateRestrictedDomainDetails(payload);
    } else {
      message.error(
        `Domain name "${this.state.newDomainName}" already exists.!`,
        2
      );
    }
  };

  addPublicEmailDomain = () => {
    if (this.state.newDomainName !== "") {
      if (this.CheckIsValidDomain(this.state.newDomainName)) {
        let mode = ADD;
        this.updateBlockedDomain(mode);
      } else {
        message.warning("Please enter a valid domain name", 2);
      }
    } else {
      message.warning("Field can't be empty.!", 2);
    }
  };

  renderAddEmailDomainFormModal = () => {

    return (
      <ConfirmationModal
        isConfirmMessage={false}
        visible={this.state.formrestrictedModalVisible}
        title={`Add Domain`}
        onCancel={() =>
          this.showHideFormModal({
            isShow: false,
            record: null,
            mode: null,
          })
        }
        loading={this.state.formButtonLoading}
        onOk={() => {
          this.addPublicEmailDomain();
        }}
        confirmButtonLabel="Submit"
      >
        {this.renderAddEmailDomainForm()}
      </ConfirmationModal>
    );
  };
  formChange = (event) => {
    if (event.target.value.length >= INPUT_CHARACTER_LIMIT) {
      message.warning("Maximum character limit reached", 2);
    } else {
      this.setState({ newDomainName: event.target.value.trim() });
    }
  };
  selectOnChange = (event) => {
    this.setState({
      selectedDomainType: event.target.value,
    });
  };
  renderAddEmailDomainForm = () => {
    let selectedItem = SELECT_OPTIONS.find((item) => {
      return item.value === this.state.selectedDomainType;
    });
    return (
      <ul className="domains-list">
        <li>
          <label>Domain Name</label>
          <Input
            placeholder={selectedItem.placeholder}
            onChange={this.formChange}
            value={this.state.newDomainName}
          />
        </li>
        <li>
          <label>Domain Type</label>
          <Radio.Group
            onChange={this.selectOnChange}
            name="radiogroup"
            value={this.state.selectedDomainType}
          >
            {SELECT_OPTIONS.map((item) => (
              <Radio value={item.value}>{item.label}</Radio>
            ))}
          </Radio.Group>
        </li>
      </ul>
    );
  };

  toggleChatIcon = (visible) => {
    let item
    const domainResponse = GetDomainDetailsStore.getResponse();

    if (!domainResponse || domainResponse.liveChat) {
      item = document.getElementById('chat-widget-container');
    } else {
      item = document.getElementsByClassName('cc-1xry cc-1gmp');
    }
    if (item && item[0]) {
      const element = item[0] || item; // Handle array-like case or single element

      // Toggle the display style based on showChatIcon state
      element.style.display = this.state.showChatIcon ? 'none' : 'block';
    } else if (window.LiveChatWidget) {
      // Fallback to LiveChatWidget calls if element is not available
      if (this.state.showChatIcon) {
        window.LiveChatWidget.call('hide');
      } else {
        window.LiveChatWidget.call('show');
        window.LiveChatWidget.call('minimize');
      }
    }
    this.setState({ showChatIcon: !this.state.showChatIcon })
    localStorage.setItem('showChatIcon', visible ? visible : !this.state.showChatIcon)

  }
  onChange = (e) => {
    this.props.onChange(e);
    this.setState({ textValue: e.target.value })
  }
  render() {
    let languageList = GetIntegrationStore.getResponse();
    const popupStyle = this.state.showLogoutPopup
      ? { display: 'block', position: 'absolute', top: '30px', right: '10px', borderRadius: '5px', marginTop: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }
      : { display: 'none' };

    const popupSuperUserStyle = this.state.showSuperUserPopup
      ? { display: 'block', position: 'absolute', top: '24px', right: '-8px', borderRadius: '5px', marginTop: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }
      : { display: 'none' };

    const menu = (
      <Menu onClick={this.changelanguage} className='lang-list'>
        {this.state.apiLangValues.map((value) => (
          languageList != null && languageList.domainLanguages && languageList.domainLanguages.includes(value)
            ? <Menu.Item key={value}>{availableLanguages[value]}</Menu.Item>
            : null
        ))}
      </Menu>
    );


    let self = this;


    return (
      <section className={style.headerContainer}>
        <div className={style.headerContainer__section}>
          <div className={style.headerContainer__section__header}>
            <h1>{this.props.header}</h1>
          </div>
          <div className={style.headerContainer__section__searchBlock}>
            {this.props.addInput && <div className={style.headerContainer__section__searchBlock__searchInput}>
              <Input
                placeholder={this.props.placeholder}
                onBlur={() => this.props.setInputFocus(false)}
                onFocus={() => this.props.setInputFocus(true)}
                onChange={this.onChange}
                value={this.props.value}
                allowClear={this.props.allowClear}
                onPressEnter={() => { this.inputRef.blur(); this.props.onPressEnter() }}
                ref={(input) => {
                  // Store a reference to the Input component
                  this.inputRef = input;
                }}
                prefix={<span>{getSVG('lens')}</span>}
              />
            </div>}
            {this.props.domainDropdown &&
              <div className={style.headerContainer__section__searchBlock__domainDropDown}>
                <span className={style.headerContainer__section__searchBlock__domainDropDown__domainSelect}>

                  <Tooltip title={this.state.currentDomain} placement="right"><Dropdown
                    overlay={this.props.changeDomainDropDown}
                  >
                    <span><img className="icon-xs" src={
                      this.props.currentDomain != 'ALL' ?
                        this.props.sourceListOption.filter(item => item.label === this.props.currentDomain && item.icon).map(item => item.icon).toString()
                        : '/images/lcicon.png'}></img></span>

                  </Dropdown></Tooltip></span>
              </div>}
            {this.props.download &&
              <div className={style.headerContainer__section__searchBlock__buttonDownload}>
                <Tooltip
                  placement='bottom'
                  title={
                    languageFile[
                    localStorage.getItem('language')
                    ]['25531']

                  }>
                  <Button
                    onClick={() => this.props.onDownloadClick()}
                    shape='circle'
                    icon='download'
                    size='large'
                    loading={
                      this.props.downloadLoading
                    }
                  />

                </Tooltip>
              </div>
            }
          </div>
          <div className={style.headerContainer__section__action}>
            <div className={style.headerContainer__section__action__adminDomaini} >
              {cookie.readCookie("superuser") &&
                <a className='header-link' onClick={() => this.backToAdmin()}>{languageFile[localStorage.getItem('language')]["10321"]}</a>
              }
            </div>


            <div className={style.headerContainer__section__action__navigationItems}>
              {this.state.language &&
                <Tooltip title='Language' position='bottom'><div className={style.headerContainer__section__action__navigationItems__languageBlock}>
                  <span>{language2letterCode[this.state.selectedLanguage]}</span>
                  {getSVG('translate')}
                </div></Tooltip>
              }

              {GetDomainDetailsStore.getResponse().chatEnabledDomains && this.state.siteSearch &&
                <div ref={this.divRef} className={style.headerContainer__section__action__navigationItems__items} onClick={this.handleDivClick}>
                  <Tooltip title="Site Search" position='bottom'>
                    {getSVG('siteSearch')}
                  </Tooltip></div>}

              {(this.state.fullScreen ||
                this.state.knowledgePanel ||
                this.state.supportTickets ||
                this.state.customNavigationLinks ||
                this.state.latestUpdates ||
                this.state.productRoadMap ||
                this.state.featureRequests ||
                this.state.liveChat)
                ?
                <>{this.state.fullScreen &&
                  <div className={style.headerContainer__section__action__navigationItems__items}>
                    <div className='dropdown header-link' onClick={!this.state.fullscreen ? this.fullScreenBrowserWindow : this.exitFullScreen}>
                      <Tooltip title="Fullscreen" position='bottom'>
                        {getSVG(!this.state.fullscreen ? 'fullScreen' : 'fullScreen-exit')}
                      </Tooltip>
                    </div>
                  </div>}
                  {this.state.knowledgePanel && GetDomainDetailsStore.getResponse().defaultDomains &&
                    <div className={style.headerContainer__section__action__navigationItems__items} onClick={this.openKnowledgePanel}>
                      <Tooltip title="Knowledge Panel" position='bottom'>
                        {getSVG('knowledgePanel')}
                      </Tooltip></div>}
                  {this.state.supportTickets && GetDomainDetailsStore.getResponse().defaultDomains &&
                    <div className={style.headerContainer__section__action__navigationItems__items} onClick={this.openSupportTicket}>
                      <Tooltip title="Support Tickets" position='bottom'>
                        {getSVG('supportTickets')}
                      </Tooltip></div>}
                  {this.state.customNavigationLinks &&
                    <div className={style.headerContainer__section__action__navigationItems__items}>
                      <Tooltip title="Custom Links " position='bottom'> <Dropdown
                        style={{ marginTop: '20px' }}
                        overlay={
                          <Menu>
                            <Menu.Item
                              key={'keys'}
                              className='custom-wrapper'>
                              <div className='custom-links'>
                                {_.map(
                                  this.state
                                    .navigationGroupItems,
                                  function (item, keys) {
                                    return self.customNavRendering(
                                      item,
                                      keys
                                    );
                                  }
                                )}
                              </div>
                            </Menu.Item>
                          </Menu>
                        }
                        trigger={['click']}
                        onClick={this.test}>
                        {getSVG('customNavigationLinks')}
                      </Dropdown></Tooltip></div>}
                  {GetDomainDetailsStore.getResponse().defaultDomains && this.state.latestUpdates &&
                    <div className={style.headerContainer__section__action__navigationItems__items}>
                      <Link to={'/authorize/iframe?externallink=https://www.localclarity.com/resources/release-notes-app'}> <Tooltip title="Platform Roadmap " position='bottom'></Tooltip><Tooltip title="Latest Updates " position='bottom'>
                        {getSVG('latestUpdates')}
                      </Tooltip></Link></div>}
                  {GetDomainDetailsStore.getResponse().defaultDomains && this.state.productRoadMap &&
                    <div className={style.headerContainer__section__action__navigationItems__items}>
                      <Link to={'/authorize/iframe?externallink=https://www.localclarity.com/development-roadmap-app'}> <Tooltip title="Platform Roadmap " position='bottom'>
                        {getSVG('productRoadMap')}
                      </Tooltip></Link></div>}
                  {GetDomainDetailsStore.getResponse().defaultDomains && this.state.featureRequests &&
                    <div className={style.headerContainer__section__action__navigationItems__items} >
                      <Link to={'/authorize/iframe?externallink=https://app.loopedin.io/localclarity-mB-o/ideas'}> <Tooltip title="Feature Request" position='bottom'>
                        {getSVG('featureRequests')}
                      </Tooltip></Link></div>}

                  {GetDomainDetailsStore.getResponse().chatEnabledDomains && this.state.liveChat && <div className={style.headerContainer__section__action__navigationItems__items} >
                    <Tooltip placement='bottom' title={this.state.showChatIcon ? 'Hide' : 'Show'}>
                      <span onClick={() => this.toggleChatIcon()}
                      >
                        {!this.state.showChatIcon ? <svg viewBox="0 -960 960 960" ><path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" /></svg>
                          : <svg viewBox="0 -960 960 960" ><path d="M280-400q-17 0-28.5-11.5T240-440q0-17 11.5-28.5T280-480q17 0 28.5 11.5T320-440q0 17-11.5 28.5T280-400Zm548 154-74-74h46v-480H274l-80-80h606q33 0 56.5 23.5T880-800v480q0 26-14.5 45.5T828-246ZM554-520l-80-80h246v80H554ZM820-28 606-240H240L80-80v-688l-52-52 56-56L876-84l-56 56ZM344-504Zm170-56Zm-234 40q-17 0-28.5-11.5T240-560q0-17 11.5-28.5T280-600q17 0 28.5 11.5T320-560q0 17-11.5 28.5T280-520Zm154-120-34-34v-46h320v80H434Zm-274-48v413l46-45h322L160-688Z" /></svg>}
                      </span></Tooltip>
                  </div>
                  }</> : ''}


              <Dropdown
                overlay={
                  CheckAdminStore.getResponse() && CheckAdminStore.getResponse().status == 200 ?
                    <Menu onClick={this.onChangePlusDropDown}>
                      <Menu.Item
                        key={'profile'}
                      >New Profile
                      </Menu.Item>
                      <Menu.Item
                        key={'portfolio'}
                      >New Portfolio
                      </Menu.Item>
                      <Menu.Item
                        key={'tier'}
                      >Create Tier
                      </Menu.Item>
                      <Menu.Item
                        key={'link'}>Add Nav Link</Menu.Item>
                      <Menu.Item
                        key={'domain'}
                      >Restrict Domain
                      </Menu.Item>

                    </Menu> :
                    <Menu onClick={this.onChangePlusDropDown}>
                      <Menu.Item
                        key={'profile'}
                      >New Profile
                      </Menu.Item>
                      <Menu.Item
                        key={'portfolio'}
                      >New Portfolio
                      </Menu.Item></Menu>
                }
                trigger='click'>
                {/* <div className={style.headerContainer__section__action__navigationItems__addElement} 
                  onClick={this.props.addClick}
                  >
                    <i className='fa fa-plus'></i>
                  </div> */}
                <div className={style.headerContainer__section__action__navigationItems__addElement}><Button ><i className='fa fa-plus'></i></Button></div>
              </Dropdown>


            </div>


            <div className={style.headerContainer__section__action__logoutSection}>
              <div className={style.headerContainer__section__action__logoutSection__image} >
                {cookie.readCookie("superuser") && cookie.readCookie("superusername") &&
                  cookie.readCookie("superuserimage") &&
                  (cookie.readCookie("superuserimage") != 'null' && cookie.readCookie("superusername") != 'null') ?
                  <Tooltip title={cookie.readCookie("superusername")}><img src={cookie.readCookie("superuserimage")} onClick={this.toggleSuperUserPopup} /></Tooltip> :
                  cookie.readCookie("superusername") != null ?
                    <Tooltip title={cookie.readCookie("superusername")}><span className={style.headerContainer__section__action__logoutSection__image__superUserImage} onClick={this.toggleSuperUserPopup}>
                      {cookie.readCookie("superusername").split(' ')[0].charAt(0).toUpperCase() + (cookie.readCookie("superusername").split(' ')[1] ?
                        cookie.readCookie("superusername").split(' ')[1].charAt(0).toUpperCase() : '')}
                    </span></Tooltip> : <></>}

                <Tooltip placement='bottom' title='Logout'>  <img onClick={this.props.enableRightNavigation} src={localStorage.getItem('userImage') +
                  '?time=' +
                  moment().format('LTS')}  ></img></Tooltip>

              </div>
              <ul className={style.headerContainer__section__action__logoutSection__dropDown} >
                <li className="dropdown">
                  <a className="dropdown-toggle header-link" >
                  </a>
                </li></ul>

              <ul className={style.headerContainer__section__action__logoutSection__dropDownSuperAdmin}>
                <li className="dropdown">
                  <div className="dropdown-menu" style={popupSuperUserStyle} ref={this.dropdownUserRef}>
                    <div className={style.superUserBlock}>
                      <div className={style.superUserBlock__header}>
                        Navigating as
                      </div>
                      <div className={style.superUserBlock__userSection}>
                        <div className={style.superUserBlock__userSection__image}>{cookie.readCookie("superuserimage") != 'null' && cookie.readCookie("superuserimage") != null ?
                          <img src={cookie.readCookie("superuserimage")} /> :
                          cookie.readCookie("superusername") != 'null' && cookie.readCookie("superusername") != null &&
                          <span className={style.superUserBlock__userSection__image__superUserImage} onClick={this.toggleSuperUserPopup}>
                            {cookie.readCookie("superusername").split(' ')[0].charAt(0).toUpperCase() + (cookie.readCookie("superusername").split(' ')[1] ?
                              cookie.readCookie("superusername").split(' ')[1].charAt(0).toUpperCase() : '')}
                          </span>
                        }</div>
                        <div className={style.superUserBlock__userSection__details}>
                          <span className={style.superUserBlock__userSection__details__name}>
                            {cookie.readCookie("superusername")}
                          </span>
                          <span className={style.superUserBlock__userSection__details__email}>
                            {cookie.readCookie("superuserid")}
                          </span>
                          <span className={style.superUserBlock__userSection__details__role}>
                            {cookie.readCookie("superuserrole") != 'null' && cookie.readCookie("superuserrole") != 'undefined' && cookie.readCookie("superuserrole")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li></ul>
            </div></div>
        </div>

        <ProgressiveModalWindow
          width={1100}
          visible={this.state.showProfileMoadal}
          onCancel={this.onCancelModal}
          children=
          {<RenderModalForm
            key={this.state.domainLogo}
            onCancel={this.onCancelModal}
            domainLogo={this.state.domainLogo}
            addNewProfile={this.addNewProfile}
            changeInvities={this.changeInvities}
            handleProfileIconChange={this.handleProfileIconChange}
            onChangeCreteProfileDetails={this.onChangeCreteProfileDetails}
            state={this.state}
            header={GetDomainDetailsStore.getResponse().domainName}
            nextStep={this.state.nextStep}
            nextStepButtonHandler={this.nextStepButtonHandler}
            previousStepButtonHandler={this.previousStepButtonHandler}

          />}

        />
        <AddPortFolioModal
          showAddProtfolioOptions={this.state.showAddProtfolioOptions}
          handleCancel={this.handlePortfolioCancel}
          loading={this.state.loadingPortFolio}
          addNewPortfolio={this.addNewPortfolio}
          newPortfolio={this.state.newPortfolio}
          newPortfolioChange={this.newPortfolioChange}
          portfolioErrorMessage={this.props.portfolioErrorMessage}
        />
        {this.renderAddEmailDomainFormModal()}
      </section>
    )
  }
}
